import { API } from "../urls";

const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: "include" };

export const getPushNotifications = async (page = 0, size = 5) => {
    const res = await fetch(API.push_notifications_page(page, size), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Push bildirimleri alınamadı");
    return res.json();
};

export const getPushNotificationPreview = async (targetScope) => {
    const res = await fetch(API.push_notifications_preview(targetScope), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Alıcı sayısı alınamadı");
    return res.json();
};

export const sendPushNotification = async (payload) => {
    const res = await fetch(API.push_notifications, {
        ...fetchOpts,
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Push bildirimi gönderilemedi");
    return res.json();
};

export const resendPushNotification = async (id) => {
    const res = await fetch(API.push_notification_resend(id), {
        ...fetchOpts,
        method: "POST",
        headers: getHeaders(),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Push bildirimi tekrar gönderilemedi");
    return res.json();
};

export const deletePushNotification = async (id) => {
    const res = await fetch(API.push_notification_detail(id), {
        ...fetchOpts,
        method: "DELETE",
        headers: getHeaders(),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Push bildirimi silinemedi");
    return res.json();
};
